__turbopack_context__.v({
  "buttonSmall": "_4NbHlq_buttonSmall",
  "titleFont": "_4NbHlq_titleFont",
});
